import type { AssetDto } from '@/api/WhisApi/generated';
import { Ionicons } from '@expo/vector-icons';
import type { ComponentProps } from 'react';

type IoniconName = ComponentProps<typeof Ionicons>['name'];

const imageExtensions = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp']);

export const isImageAsset = (fileName: string): boolean => {
  const extension = fileName.split('.').pop()?.toLowerCase() ?? '';
  return imageExtensions.has(extension);
};

export const getAssetDisplayName = (asset: AssetDto): string =>
  asset.name || asset.fileName;

export const getAssetIconName = (fileName: string): IoniconName => {
  const extension = fileName.split('.').pop()?.toLowerCase() ?? '';

  if (imageExtensions.has(extension)) {
    return 'image-outline';
  }

  if (extension === 'pdf') {
    return 'document-text-outline';
  }

  return 'document-outline';
};
